export class esquemas
{
    public idEsquemaPK: number;   
    public idAnt:number;
    public clave: string;
    public descripcion: string;
}